export default __webpack_public_path__ + "static/media/Union.84671718.svg";